import jsforce from 'jsforce'
import axios from 'axios'

const axiosMain = axios.create({
  baseURL: process.env.SFCONNECT_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

class Salesforce {
  constructor () {
    this.conn = null
  }

  login () {
    this.conn = new jsforce.Connection({
      oauth2: {
        // you can change loginUrl to connect to sandbox or prerelease env.
        loginUrl: 'https://test-ionis-sf.herokuapp.com',
        clientId: process.env.SF_APP_CLIENT_ID,
        clientSecret: process.env.SF_APP_CLIENT_SECRET,
        redirectUri: 'http://localhost:8080'
      }
    })
    return new Promise((resolve, reject) => {
      resolve(true)
    })
  }

  loginEpitech () {
    this.conn = new jsforce.Connection({
      oauth2: {
        // you can change loginUrl to connect to sandbox or prerelease env.
        loginUrl: 'https://test-ionis-sf.herokuapp.com',
        clientId: '3MVG9Rd3qC6oMalV_xX6j4wZizDGygB0zWmkT86OtWuHlI_cJQC9om4kJ.FIejuPNBvT1xtGAUZmvX8NPD3ia',
        clientSecret: '52D929F526CA773E53400E6C5F398F1EC122DDAB1FDDCD49EFD1FE44485D2E08',
        redirectUri: 'http://localhost:8080'
      }
    })
    return new Promise((resolve, reject) => {
      this.conn.login('celine.baraban@epitech.eu', 'JMSalesforce42shv9BXx7Uag9dn2cJi7kWlmyYhW', function (err, userInfo) {
        if (err) { reject(new Error('Erreur connexion Salesforce')) }
        if (!err) {
          console.log('connexion SF OK')
          resolve(true)
        }
      })
    })
  }

  create (sObject) {
    return new Promise((resolve, reject) => {
      axiosMain({
        method: 'post',
        url: 'eventdb-salesforce/createCampaign',
        data: sObject
      }).then((val) => {
        if (val.data.success) {
          resolve(val.data.data)
        }
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }

  createEda (sObject) {
    return new Promise((resolve, reject) => {
      axiosMain({
        method: 'post',
        url: 'eventdb-salesforce-eda/createCampaign',
        data: sObject
      }).then((val) => {
        if (val.data.success) {
          resolve(val.data.data)
        }
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }

  getLeadCampaignMember (items) {
    let ids = []
    for (let i = 0; i < items.length; i++) {
      if (items[i].salesforce_campaign !== '') {
        ids.push('\'' + items[i].salesforce_campaign + '\'')
      }
    }
    let inIds = '(' + ids.join(',') + ')'
    // let eventDBIds = []
    return new Promise((resolve, reject) => {
      axiosMain({
        method: 'get',
        url: 'eventdb-salesforce/getLeadCampaignMember?ids=' + inIds
      }).then((val) => {
        if (val.data.success) {
          resolve(val.data.data)
        }
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }

  getLeadCampaignMemberEda (items) {
    let ids = []
    for (let i = 0; i < items.length; i++) {
      if (items[i].salesforce_campaign !== '') {
        ids.push('\'' + items[i].salesforce_campaign + '\'')
      }
    }
    let inIds = '(' + ids.join(',') + ')'
    // let eventDBIds = []
    return new Promise((resolve, reject) => {
      axiosMain({
        method: 'get',
        url: 'eventdb-salesforce-eda/getLeadCampaignMember?ids=' + inIds
      }).then((val) => {
        if (val.data.success) {
          resolve(val.data.data)
        }
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }

  update (sObject) {
    return new Promise((resolve, reject) => {
      axiosMain({
        method: 'post',
        url: 'eventdb-salesforce/updateCampaign',
        data: sObject
      }).then((val) => {
        if (val.data.success) {
          resolve(val.data.data)
        }
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }

  updateEda (sObject) {
    return new Promise((resolve, reject) => {
      axiosMain({
        method: 'post',
        url: 'eventdb-salesforce-eda/updateCampaign',
        data: sObject
      }).then((val) => {
        if (val.data.success) {
          resolve(val.data.data)
        }
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }
}

export default Salesforce



// WEBPACK FOOTER //
// ./src/class/Salesforce.js